// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.form-group label {
  display: block;
  margin-bottom: 0.45rem;
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/deep-cleaning-log-modal/deep-cleaning-log-modal.component.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;AACA;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;AACF","sourcesContent":[".form-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n.form-group label {\n  display: block;\n  margin-bottom: 0.45rem;\n  font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
